import { GrowerProgramRequest } from '@cibo/core'
import { usePaginatedFields } from '@cibo/landmanager'
import { Loading, useAuth } from '@cibo/profile'
import { useProgram } from '@cibo/programs'
import { Markdown } from '@cibo/ui'
import ChevronRightRounded from '@mui/icons-material/ChevronRightRounded'
import { Box, Button, Stack } from '@mui/material'
import { LAND_MANAGER_ROUTES } from 'navigation/types/routes'
import { useNeedsInfoFieldsCount } from 'pages/ProfileFields'
import { Qualifications } from 'pages/ProgramDetails/contentBlocks'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

export const EngagementImpossible = ({ programId }: Pick<GrowerProgramRequest, 'programId'>) => {
  const { t } = useTranslation('impact/components/EngagementImpossible')
  const { persona } = useAuth()
  const totalFields = usePaginatedFields(0, 1)

  const program = useProgram({ programId })
  const unprofiled = useNeedsInfoFieldsCount()

  if (!program.isFetched || !totalFields.isFetched) return <Loading />

  return program.data?.enrollmentWindow.enrollmentStatus === 'closed' ? (
    <Markdown color="text.secondary">{t('closedMd')}</Markdown>
  ) : !totalFields.data?.numAvailable ? (
    <Stack spacing={2} maxWidth={450}>
      <Markdown color="text.secondary">{t('addFieldsMd')}</Markdown>
      <Box>
        <Button
          size="large"
          color="secondary"
          component={Link}
          to={LAND_MANAGER_ROUTES.ADD}
          variant="contained"
          endIcon={<ChevronRightRounded />}
        >
          {t('addFields')}
        </Button>
      </Box>
    </Stack>
  ) : totalFields.data?.numAvailable === unprofiled.data?.numAvailable ? (
    <Stack spacing={2} maxWidth={450}>
      <Markdown color="text.secondary">
        {t('addInformationMd', { count: unprofiled.data.numAvailable })}
      </Markdown>
      <Box>
        <Button
          size="large"
          color="warning"
          component={Link}
          to={LAND_MANAGER_ROUTES.ADD}
          variant="contained"
          endIcon={<ChevronRightRounded />}
        >
          {t('addInformation')}
        </Button>
      </Box>
    </Stack>
  ) : (
    <Stack spacing={6}>
      <Stack spacing={3}>
        <Box maxWidth={500}>
          <Markdown color="text.secondary">
            {t('engagementImpossibleAllUsersMd', {
              count: totalFields.data?.numAvailable,
              context: persona,
            })}
          </Markdown>
        </Box>
        <Box>
          <Button
            variant="contained"
            size="large"
            color="secondary"
            component={Link}
            to={LAND_MANAGER_ROUTES.ADD}
            endIcon={<ChevronRightRounded />}
          >
            {t('addFields')}
          </Button>
        </Box>
      </Stack>
      <Stack spacing={2}>
        <Markdown color="text.secondary">{t('qualifyingCriteriaMd')}</Markdown>
        {program.data?.content && <Qualifications program={program.data?.content} />}
      </Stack>
    </Stack>
  )
}
